module.exports = __webpack_public_path__ + "static/img/tx4.a9c98c13.png";